@let isMultiSelection = sections().length > 1;

<div class="toolbar">
  @if (isMultiSelection) {
    <p class="count full-width">
      {{ 'sections_editor.selected_count' | translate: { count: sections().length } }}
    </p>
  } @else {
    <kin-icon name="timer" [color]="colorService.neutral400()" />

    <div class="time">
      <input
        type="number"
        name="minutes"
        [value]="section().duration.minutes"
        (change)="onTimeChange('minutes', $event.target.value)"
      />
      <p>:</p>
      <input
        type="number"
        name="seconds"
        step="10"
        [value]="section().duration.seconds"
        (change)="onTimeChange('seconds', $event.target.value)"
      />
    </div>
    @for (sectionData of sectionDatas(); track $index) {
      <div class="data" [class.full-width]="$index === 2">
        <kin-icon
          [color]="colorService.neutral400()"
          [name]="sectionEditorService.getWorkoutModeIcon(sectionData.type)"
        />
        <label class="value-field">
          <input
            [appAutoWidth]="sectionData.value"
            type="number"
            name="data"
            [value]="sectionData.value"
            [min]="sectionEditorService.fieldBounds(sectionData.type).min"
            [max]="sectionEditorService.fieldBounds(sectionData.type).max"
            [step]="sectionEditorService.fieldBounds(sectionData.type).step"
            (change)="onDataChange(sectionData.type, $event.target.value)"
          />
          <span class="unit">{{ sectionEditorService.getWorkoutModeUnit(sectionData.type) }}</span>
        </label>
      </div>
    }
    @if (section().cadence !== undefined) {
      <div class="data full-width">
        <kin-icon [color]="colorService.neutral400()" name="cadence" />
        <label class="value-field">
          <input
            [appAutoWidth]="section().cadence"
            type="number"
            name="cadence"
            [value]="section().cadence"
            [min]="cadenceBounds.min"
            [max]="cadenceBounds.max"
            [step]="cadenceBounds.step"
            (change)="onCadenceChange($event.target.value)"
            (blur)="onCadenceBlur($event.target.value)"
          />
          <span class="unit">%</span>
        </label>
      </div>
    } @else if (sectionEditorService.canHaveCadence(sectionEditorService.workoutMode())) {
      <button type="button" class="add-data full-width" (click)="addCadence()">
        <kin-icon [color]="colorService.brandSecondary400()" name="add_circle" />
        <p>{{ 'sections_editor.add_cadence' | translate }}</p>
      </button>
    }
  }

  <div class="actions">
    <button
      class="move"
      (click)="move.emit('left')"
      [disabled]="!sectionEditorService.canMoveSelectionLeft()"
    >
      <kin-icon [color]="colorService.brandSecondary400()" name="arrow_left" [size]="18" />
    </button>

    <button
      class="move"
      (click)="move.emit('right')"
      [disabled]="!sectionEditorService.canMoveSelectionRight()"
    >
      <kin-icon [color]="colorService.brandSecondary400()" name="arrow_right" [size]="18" />
    </button>

    <button class="duplicate" (click)="duplicate.emit()" [disabled]="">
      <kin-icon [color]="colorService.brandSecondary400()" name="duplicate" [size]="18" />
    </button>
    <button class="delete" (click)="delete.emit()">
      <kin-icon [color]="colorService.backgroundColor()" [size]="18" name="trash" />
    </button>
  </div>
</div>
